import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13e91366&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13e91366')) {
      api.createRecord('13e91366', component.options)
    } else {
      api.reload('13e91366', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13e91366&", function () {
      api.rerender('13e91366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/customers/orderRateChart/index.vue"
export default component.exports